// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "Comisiones de las OTAs",
    sub: "Lo que se queda cada canal de tus reservas. Con esto la ficha de cada reserva te da una estimación de lo que te llega.",
  },
  loading: "Cargando las comisiones…",
  loadError: {
    title: "No se han podido cargar las comisiones",
    text: "Comprueba la conexión e inténtalo de nuevo.",
    retry: "Reintentar",
  },
  display: {
    title: "Precio de las reservas de OTA en la ficha",
    totalLabel: "Solo el total que envía la OTA",
    totalDesc: "Como hasta ahora: el importe de la reserva.",
    netLabel: "También lo que te llega",
    netDesc: "Además del total, la ficha muestra la comisión, el IVA de la comisión y el neto que recibirás.",
  },
  rates: {
    title: "Comisión y cargos de cada OTA",
    hint: "Pon el % que ves en el extranet de cada OTA (en Booking: «Comisión y cargos» ÷ «Precio total»). Si el canal informa la comisión real de una reserva, se usa esa.",
    usual: "habitual: {pct} %",
    airbnbNote: "Airbnb te paga el importe ya neto: su comisión viene descontada. Déjalo vacío (0 %) salvo que tu conexión reciba el total.",
    managedNote: "Estos porcentajes también se usan en la liquidación a tu propietario.",
  },
  vat: {
    title: "IVA sobre la comisión de la OTA",
    hint: "Booking cobra IVA sobre su comisión a los alojamientos de España (21 %) y lo descuenta de la transferencia. Pon 0 si no te lo cobran.",
  },
  errPercent: "Tiene que ser un porcentaje entre 0 y 100.",
  example: {
    title: "Ejemplo",
    sub: "Una reserva de {channel} de {total}",
    total: "Precio total",
    commission: "Comisión y cargos de {channel} ({pct} %)",
    vat: "IVA de la comisión ({pct} %)",
    net: "Te llega",
    foot: "Es una estimación con estos porcentajes: la OTA puede transferir una cifra algo distinta (redondeos, promociones, cargos por pago). Si el canal informa la comisión real, la ficha usa esa.",
  },
  footer: {
    save: "Guardar",
    saving: "Guardando…",
    saved: "Comisiones guardadas",
    unsaved: "Cambios sin guardar",
    fixErrors: "Revisa los campos marcados",
    errSave: "No se han podido guardar los cambios. Inténtalo de nuevo.",
    errInvalid: "La comisión de cada OTA tiene que ser un porcentaje entre 0 y 100.",
  },
};
